import { createSlice } from '@reduxjs/toolkit'

import { initialState, PARTICIPANT_LABELS_SLICE_NAME } from './constants'
import { fetchConversationParticipantLabelsThunk } from './thunks'

export default createSlice({
  name: PARTICIPANT_LABELS_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchConversationParticipantLabelsThunk.fulfilled,
      (state, action) => {
        action.payload.participantLabels.forEach((participant) => {
          state.byParticipantId[participant.id] = participant.label || []
        })
        state.loadedByConversationId[action.payload.conversationId] = true
        state.loadingByConversationId[action.payload.conversationId] = false
        state.failedByConversationId[action.payload.conversationId] = false
      }
    )
    builder.addCase(
      fetchConversationParticipantLabelsThunk.pending,
      (state, action) => {
        state.loadingByConversationId[action.meta.arg] = true
        state.failedByConversationId[action.meta.arg] = false
      }
    )
    builder.addCase(
      fetchConversationParticipantLabelsThunk.rejected,
      (state, action) => {
        if (action.meta.condition) return

        state.loadingByConversationId[action.meta.arg] = false
        if (!action.meta.aborted) {
          state.failedByConversationId[action.meta.arg] = true
        }
      }
    )
  },
}).reducer